import { Close, Delete, Edit, Input, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Card,
  FormControlLabel,
  FormGroup,
  Icon,
  Pagination,
  Stack,
  IconButton,
  Switch,
  Tooltip,
  Avatar,
  AvatarGroup,
  MenuItem,
  Select,
} from "@mui/material";
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import SkLoading from "components/SkLoading";
import SkModal from "components/SkModal";
import SkConfirm from "components/SkComfirm";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleAlert } from "redux/festures/alertSlice";
import { updateCoupons } from "redux/festures/couponsSlice";
import { getSingleCoupons } from "redux/festures/couponsSlice";
import { getAllCoupons } from "redux/festures/couponsSlice";
import { SkPrice } from "Utils/dateFunc";
import { formattedDateServer } from "Utils/dateFunc";
// import SingleCoupons from "./SingleCoupons";
import Form from "./Form";
import SingleCoupons from "./SingleCoupons";
import { getGlobalCoupons } from "redux/festures/couponsSlice";
import { getCategory } from "redux/festures/categorySlice";
import MDBadge from "components/MDBadge";
import ApnaSelect from "components/ApnaSelect/ApnaSelect";

// import Form from "./Form";
// import SingleBlog from "./SingleBlog";
const columns = {
  AllCoupons: [
    { Header: "S.No", accessor: "no" },
    { Header: " details", accessor: " details" },
    { Header: "date", accessor: "date" },
    { Header: "coupon - % / qty", accessor: "coupon - % / qty" },
    {
      Header: "min order price / max discount price",
      accessor: "min order price / max discount price",
    },
    {
      Header: "type",
      accessor: "type",
    },
    {
      Header: "category",
      accessor: "category",
    },
    // { Header: "disable", accessor: "disable" },
    { Header: "delete", accessor: "delete" },
    { Header: "view", accessor: "view" },
    { Header: "action", accessor: "action" },
  ],
};

const disableFilter = [
  {
    _id: 0,
    name: "All",
  },
  {
    _id: true,
    name: "Disable",
  },
  {
    _id: false,
    name: "Active",
  },
];

const typeFilterOptions = [
  { _id: "ALL", name: "All Types" },
  { _id: "CATEGORY", name: "Service Coupons" },
  { _id: "ECOM_CATEGORY", name: "E-Commerce Coupons" },
];

const Coupons = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const admin = localStorage.getItem("admin_id");
  const dispatch = useDispatch();
  const [rowsData, setRowsData] = useState([]);
  const { Loading, coupons, singleCoupons,isPages } = useSelector((data) => data?.isCoupons) || {};
  const [isOpen, setIsOpen] = useState(false);
  const [istype, setIsType] = useState("");
  const [isOpenView, setIsOpenView] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenDialog, setIsOpenDialog] = useState({
    open: false,
    isId: null,
    isRestore: false,
    title: "",
  });
  const { category } = useSelector((state) => ({
    ...state.isCategory,
  }));

  const [filter, setFilter] = useState(false);
  const [selectedType, setSelectedType] = useState("ALL");
  const [pagess, setPagess] = useState(1);

  useEffect(() => {
    const typeQuery = selectedType && selectedType !== "ALL" ? `&type=${selectedType}` : "";
    dispatch(
      getAllCoupons(
        `${process.env.REACT_APP_APII}/getAllCouponByAdmin/${admin}?disable=${
          filter === false ? false : filter || ""
        }&page=${pagess || ""}${typeQuery}`
      )
    );
  }, [filter, pagess, selectedType]);
  // console.log(coupons, "coupons");
  useEffect(() => {
    dispatch(getCategory(`${process.env.REACT_APP_APII}/getAllCategoryByAdmin/${admin}?disable=false`));
  }, []);
  useEffect(() => {
    if (coupons && coupons.length > 0) {
      const temprows =
        coupons &&
        coupons?.at(0) &&
        coupons?.map((value, index) => ({
          no: (
            <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
              {index + 1}
            </MDTypography>
          ),
          " details": (
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <MDBox sx={{ height: 40, width: 40 }}>
                <img
                  src={`${process.env.REACT_APP_URI}/${value?.icon}`}
                  alt={"img"}
                  onError={(e) => {
                    (e.onError = null),
                      (e.target.src = require("../../assets/images/bg-profile.png"));
                  }}
                  style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                />
              </MDBox>
              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: 1,
                  flexDirection: "column",
                }}
              >
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                >
                  Name:
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                  style={{
                    maxWidth: "250px",
                    lineHeight: "20px",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {value?.couponName || "N/A"}
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                  fontSize={12.5}
                  style={{
                    maxWidth: "250px",
                    lineHeight: "20px",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  CouponCode:
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                  fontSize={12.5}
                >
                  {value?.couponCode || "N/A"}
                </MDTypography>
                {/* <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                  fontSize={10}
                >
                  ID: {value?._id || "N/A"}
                </MDTypography> */}
              </MDBox>
            </MDBox>
          ),
          date: (
            <MDBox flexDirection="column">
              <MDTypography fontSize={12.5}>
                Str At : {formattedDateServer(new Date(value?.startDate))}
              </MDTypography>
              <MDTypography fontSize={12.5}>
                Ex At : {formattedDateServer(new Date(value?.expiryDate))}
              </MDTypography>
              <MDTypography fontSize={12.5}>Validity : {value?.validity} Days</MDTypography>
            </MDBox>
          ),
          "coupon - % / qty": (
            <MDBox flexDirection="column">
              <MDTypography fontSize={12.5}>
                {value?.couponPercent || "N/A"}% / {value?.couponQuantity || "N/A"} .Qty
              </MDTypography>
              {/* <MDTypography fontSize={12.5}>Qty : {value?.couponQuantity || "N/A"}</MDTypography> */}
            </MDBox>
          ),
          "min order price / max discount price": (
            <MDBox flexDirection="column">
              <MDTypography fontSize={12.5}>min order :</MDTypography>
              <MDTypography fontSize={12.5}>{SkPrice(value?.minOrderPrice) || "N/A"}</MDTypography>
              <MDTypography fontSize={12.5}>max discount :</MDTypography>
              <MDTypography fontSize={12.5}>
                {SkPrice(value?.maxDiscountPrice) || "N/A"}
              </MDTypography>
            </MDBox>
          ),
          type: (
            <MDBadge
              badgeContent={value?.type == "ECOM_CATEGORY" ? "ECOM CATEGORY" : "SERVICE CATEGORY"}
              color={value?.type == "ECOM_CATEGORY" ? "success" : "error"}
              variant="gradient"
              size="lg"
            />
          ),
          // <MDTypography fontSize={12.5}>{value?.type || "N/A"}</MDTypography>

          category: (
            <MDBox display="flex" flexDirection="column" gap={0.5}>
              {(() => {
                const cats =
                  value?.type === "ECOM_CATEGORY"
                    ? value?.eComCategoryId
                    : value?.categoryId;
                if (!cats || cats.length === 0) {
                  return (
                    <MDTypography variant="caption" color="text" fontWeight="medium">
                      All Categories
                    </MDTypography>
                  );
                }
                return cats.map((ele, i) => (
                  <MDBox key={i} display="flex" alignItems="center" gap={0.8}>
                    {ele?.banner?.at(0)?.url ? (
                      <Avatar
                        src={`${process.env.REACT_APP_URI}/${ele?.banner?.at(0)?.url}`}
                        sx={{ width: 22, height: 22 }}
                      />
                    ) : null}
                    <MDTypography variant="caption" fontWeight="medium" color="text">
                      {ele?.name || ele?.title || "N/A"}
                    </MDTypography>
                  </MDBox>
                ));
              })()}
            </MDBox>
          ),

          view: (
            <IconButton
              aria-label="action_edit"
              onClick={() => {
                setIsOpenView(true);
                dispatch(getSingleCoupons(value));
              }}
            >
              <Visibility
                sx={({ palette: { dark, white, info } }) => ({
                  color: darkMode ? info.main : dark.main,
                })}
              />
            </IconButton>
          ),
          disable: (
            <Switch
              value={value?.disable}
              checked={value?.disable}
              color={"info"}
              onChange={(e) => {
                // handleSwitchControl(value?._id);
                // setIsSwitch(!isSwitch);
                dispatch(
                  updateCoupons({
                    url: `${process.env.REACT_APP_APII}/disableCoupon/${value?._id}/${admin}`,
                  })
                ).then((data) => {
                  dispatch(
                    handleAlert({
                      isOpen: true,
                      type: `${data?.payload?.success ? "success" : "error"}`,
                      msg: data?.payload?.message,
                    })
                  );
                  if (data?.payload?.success) {
                    dispatch(
                      getAllCoupons(
                        `${process.env.REACT_APP_APII}/getAllCouponByAdmin/${admin}?disable=${
                          filter === false ? false : filter || ""
                        }`
                      )
                    );
                  }
                });
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          ),

          delete: (
            <Tooltip title={value?.disable ? "move to Active" : "delete"}>
              <IconButton
                aria-label="action_edit"
                // disabled={value?.disable}
                onClick={() => {
                  setIsOpenDialog({
                    open: true,
                    isId: value?._id,
                    isRestore: Boolean(value?.disable),
                    title: value?.coupon_name || "this coupon",
                  });
                }}
              >
                {value?.disable ? (
                  <Input
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? info.main : dark.main,
                    })}
                  />
                ) : (
                  <Delete
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? info.main : dark.main,
                    })}
                  />
                )}
              </IconButton>
            </Tooltip>
            // <IconButton
            //   disabled={value?.disable === true}
            //   aria-label="action_edit"
            //
            // >
            //   <Delete
            //     sx={({ palette: { dark, white, info } }) => ({
            //       color: darkMode ? info.main : dark.main,
            //     })}
            //   />
            // </IconButton>
          ),
          // showInHome: (
          //   <Switch
          //     value={value?.showInHome}
          //     checked={value?.showInHome}
          //     color={"info"}
          //     onChange={(e) => {
          //       // handleSwitchControl(value?._id);
          //       // setIsSwitch(!isSwitch);
          //       dispatch(
          //         updateCoupons({
          //           url: `${process.env.REACT_APP_API}/ShowInHomeBlog/${value?._id}/${admin}`,
          //         })
          //       ).then((data) => {
          //         dispatch(
          //           handleAlert({
          //             isOpen: true,
          //             type: `${data?.payload?.success ? "success" : "error"}`,
          //             msg: data?.payload?.message,
          //           })
          //         );
          //         if (data?.payload?.success) {
          //           dispatch(getAllcoupons(`/getAllBlog?adminId=${admin}`));
          //         }
          //       });
          //     }}
          //     inputProps={{ "aria-label": "controlled" }}
          //   />
          // ),
          action: (
            <>
              <IconButton
                aria-label="action_edit"
                onClick={() => {
                  setIsOpen(true);
                  setIsOpenUpdate(true);
                  // console.log(value?._id);
                  dispatch(getSingleCoupons(value));
                }}
              >
                <Edit
                  sx={({ palette: { dark, white, info } }) => ({
                    color: darkMode ? info.main : dark.main,
                  })}
                />
              </IconButton>
            </>
          ),
        }));
      setRowsData(temprows);
    } else {
      setRowsData(["", " "]);
    }
  }, [coupons]);
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mb={2} />
        <MDBox py={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MDTypography variant="h6" color="white">
                Coupon&apos;s Table{" "}
              </MDTypography>
              <MDBox display="flex" gap="5px">
                <MDButton
                  variant="gradient"
                  disabled={Loading}
                  color="dark"
                  sx={({ palette: { dark, white, info, success } }) => ({
                    color: white.main,
                    backgroundColor: dark.main,
                    "&:hover": {
                      color: success.main,
                      backgroundColor: success.main,
                    },
                  })}
                  onClick={() => {
                    setIsOpen(true);
                    setIsOpenUpdate(false);
                    setIsType("ECOM_CATEGORY");
                  }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp; Create E-com Coupon
                </MDButton>
                <MDButton
                  variant="gradient"
                  disabled={Loading}
                  color="dark"
                  sx={({ palette: { dark, white, info, success } }) => ({
                    color: white.main,
                    backgroundColor: dark.main,
                    "&:hover": {
                      color: success.main,
                      backgroundColor: success.main,
                    },
                  })}
                  onClick={() => {
                    setIsOpen(true);
                    setIsOpenUpdate(false);
                    setIsType("CATEGORY");
                  }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp; Create Service Coupon
                </MDButton>
              </MDBox>
            </MDBox>

            <MDBox py={2} display="flex" justifyContent="flex-end" gap={2}>
              <MDBox width="23%" display="flex" flexDirection="column" pt={2}>
                <MDTypography variant="button">Filter By Type</MDTypography>
                <Select
                  disabled={Loading}
                  displayEmpty
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                  sx={({ palette: { dark, white } }) => ({
                    width: "100%",
                    height: "3rem",
                    color: darkMode ? white?.main : dark?.main,
                    bgcolor: "transparent",
                    "& .MuiSelect-icon": {
                      color: darkMode ? white?.main : dark?.main,
                      display: "block !important",
                      fontSize: "1.5rem !important",
                    },
                  })}
                >
                  {typeFilterOptions?.map((ele, i) => (
                    <MenuItem component="option" key={i} value={ele?._id}>
                      {ele?.name}
                    </MenuItem>
                  ))}
                </Select>
              </MDBox>

              <MDBox width="23%" display="flex" flexDirection="column" pt={2}>
                <MDTypography variant="button">Filter By Visibility</MDTypography>
                <Select
                  disabled={Loading}
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  sx={({ palette: { dark, white } }) => ({
                    width: "100%",
                    height: "3rem",
                    color: darkMode ? white?.main : dark?.main,
                    bgcolor: "transparent",
                    "& .MuiSelect-icon": {
                      color: darkMode ? white?.main : dark?.main,
                      display: "block !important",
                      fontSize: "1.5rem !important",
                    },
                  })}
                >
                  {disableFilter?.map((ele, i) => (
                    <MenuItem component="option" key={i} value={ele?._id}>
                      {ele?.name}
                    </MenuItem>
                  ))}
                </Select>
              </MDBox>
            </MDBox>
            <MDBox py={3}>
              {Loading ? (
                <SkLoading />
              ) : coupons && coupons.length > 0 ? (
                <>
                <DataTable
                  table={{
                    columns: columns?.AllCoupons,
                    rows: rowsData,
                  }}
                  isSorted={false}
                  entriesPerPage={false}
                  isPages={coupons && coupons.length}
                  noEndBorder
                  canSearch={false}
                  showTotalEntries={false}
                  pagination={false}
                  isPagination={false}
                />
                <MDBox
                sx={{
                  mt: 5,
                  // minHeigth: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Stack spacing={2} direction={"row"}>
                  <Pagination
                    sx={({ palette: { dark, white, info } }) => ({
                      "&.MuiPaginationItem-text": {
                        color: darkMode ? white.main : dark.main,
                      },
                      "&	.MuiPaginationItem-icon": {
                        color: darkMode ? white.main : dark.main,
                      },
                      "&		.MuiPaginationItem-textInfo": {
                        color: darkMode ? white.main : dark.main,
                      },
                    })}
                    color="info"
                    variant="text"
                    count={isPages}
                    page={pagess}
                    onChange={(e, value) => setPagess(value)}
                  />
                </Stack>
              </MDBox>
                </>
              ) : (
                <MDBox
                  // key={index}
                  display="flex"
                  justifyContent="center"
                  gap={2}
                  alignItems="center"
                  // width={"100%"}
                >
                  <MDTypography variant="h5">Coupons Not found !</MDTypography>
                </MDBox>
              )}
            </MDBox>
          </Card>
        </MDBox>
        <Footer />
      </DashboardLayout>
      <SkModal
        show={isOpen}
        unShow={setIsOpen}
        // type={istype}

        width={{ sx: "100%", md: "65%", xl: "65%", sm: "100%" }}
        height={"88vh"}
        padding={3}
        overflowY={true}
      >
        <Form
          isOpenUpdate={isOpenUpdate}
          setIsOpenUpdate={setIsOpenUpdate}
          setIsOpen={setIsOpen}
          type={istype}
          filter={filter}
        />
      </SkModal>
      <SkModal
        show={isOpenView}
        unShow={setIsOpenView}
        width={{ sx: "100%", md: "65%", xl: "65%", sm: "100%" }}
        height={"90vh"}
        padding={3}
        overflowY={true}
      >
        <SingleCoupons />
      </SkModal>
      <SkConfirm
        dialogTitle={isOpenDialog?.isRestore ? "Confirm Restore" : "Confirm Delete"}
        dialogContent={`Are you sure you want to ${
          isOpenDialog?.isRestore ? "restore" : "delete"
        } ${isOpenDialog?.title || "this coupon"}?`}
        open={isOpenDialog}
        setOpen={setIsOpenDialog}
        rate={isOpenDialog?.isRestore}
        dialogAction={
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,
              px: 3,
            }}
          >
            <MDButton
              variant="gradient"
              color="info"
              sx={{ width: "50%" }}
              onClick={() => {
                setIsOpenDialog((Preview) => ({
                  ...Preview,
                  open: false,
                  isId: null,
                }));
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              sx={{ width: "50%" }}
              color={isOpenDialog?.isRestore ? "info" : "error"}
              onClick={() => {
                const targetId = isOpenDialog?.isId;
                setIsOpenDialog((Preview) => ({
                  ...Preview,
                  open: false,
                  isId: null,
                }));
                if (targetId) {
                  dispatch(
                    updateCoupons({
                      url: `${process.env.REACT_APP_APII}/disableCoupon/${
                        targetId
                      }/${admin}?disable=${filter || ""}`,
                    })
                  ).then((data) => {
                    dispatch(
                      handleAlert({
                        isOpen: true,
                        type: `${data?.payload?.success ? "success" : "error"}`,
                        msg: data?.payload?.message,
                      })
                    );
                    if (data?.payload?.success) {
                      const typeQuery =
                        selectedType && selectedType !== "ALL" ? `&type=${selectedType}` : "";
                      dispatch(
                        getAllCoupons(
                          `${
                            process.env.REACT_APP_APII
                          }/getAllCouponByAdmin/${admin}?disable=${
                            filter === false ? false : filter || ""
                          }&page=${pagess || ""}${typeQuery}`
                        )
                      );
                    }
                  });
                }
              }}
            >
              {isOpenDialog?.isRestore ? "Restore" : "Delete"}
            </MDButton>
          </MDBox>
        }
      />
    </>
  );
};

export default Coupons;
